'use client';

import { c as _c } from "react/compiler-runtime";
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from '@uzh-bf/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import * as React from 'react';
import { useEffect } from 'react';
import RichTextHtml from 'src/components/RichTextHtml';
import { twMerge } from 'tailwind-merge';
import { AspectRatio } from './EmbedBlock';
export default function CarouselBlock(t0) {
  const $ = _c(29);
  const {
    title,
    description,
    items
  } = t0;
  const [api, setApi] = React.useState();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const t = useTranslations();
  let t1;
  let t2;
  if ($[0] !== api) {
    t1 = () => {
      if (!api) {
        return;
      }
      setCount(api.scrollSnapList().length);
      setCurrent(api.selectedScrollSnap() + 1);
      api.on("select", () => {
        setCurrent(api.selectedScrollSnap() + 1);
      });
    };
    t2 = [api];
    $[0] = api;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== description) {
    t3 = description && <RichTextHtml data={description} />;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      loop: true
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== items || $[7] !== title) {
    let t6;
    if ($[9] !== title) {
      t6 = (item, index) => <CarouselItem key={index} className="object-contain"><div className={twMerge("relative w-full", item.aspectRatio === "16to9" && "aspect-video", item.aspectRatio === "4to3" && "aspect-[4/3]", item.aspectRatio === "square" && "aspect-square")}><Image alt={title} src={item.embedUrl} layout="fill" objectFit="contain" /></div></CarouselItem>;
      $[9] = title;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = items.map(t6);
    $[6] = items;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <CarouselContent>{t5}</CarouselContent>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CarouselPrevious className="relative left-0 top-0 ml-4 flex translate-y-0" variant="outline" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== count || $[15] !== current || $[16] !== t) {
    t8 = t("unit.slideIndex", {
      current,
      count
    });
    $[14] = count;
    $[15] = current;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <div className="text-muted-foreground text-center text-sm">{t8}</div>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <CarouselNext className="relative left-0 top-0 mr-4 flex translate-y-0" variant="outline" />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t9) {
    t11 = <div className="flex flex-row items-center justify-between">{t7}{t9}{t10}</div>;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t6) {
    t12 = <div className="mx-auto max-w-2xl"><Carousel setApi={setApi} className="w-full" opts={t4}>{t6}{t11}</Carousel></div>;
    $[23] = t11;
    $[24] = t6;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t3) {
    t13 = <div className="h-3/4 w-full">{t3}{t12}</div>;
    $[26] = t12;
    $[27] = t3;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}